import tgamConfig from "config/tgam";
import ee from "lib/eventemitter";
import OnboardingMessage from "ui/onboarding-message";
import { qs } from "utils/utils";

export default function initEditorialBoardMessage() {
  const messageEnabled = tgamConfig.env.editorialBoardMessageEnabled === "true" ? true : false;
  const messageText = tgamConfig.env.editorialBoardMessage;
  const button = qs(".arc-editorial-board-button");

  if (!messageEnabled || !messageText || !button) {
    return;
  }
  button.classList.remove("u-hidden");

  let messagePosition = "bottom";
  let arrowPosition = "center";

  // This matchMedia rule is in sync with the media query in editorial-board-message.scss
  if (window.matchMedia("(min-width: 42rem)").matches) { // 672px
    messagePosition = "middle";
    arrowPosition = "right";
  }

  const message = new OnboardingMessage({
    targetElement: button,
    insertPosition: "afterend",
    id: "arc-editorial-board-msg",
    message: messageText,
    messagePosition,
    arrowPosition,
    localStorageItem: null,
    staticPos: false,
    delay: null,
    closeOnBodyClick: true
  });

  button.addEventListener("click", () => {
    if (message.isHidden()) {
      message.reveal();
      sendAnalytics();
    } else if (message.isVisible()) {
      message.hide();
    }
  });
}

function sendAnalytics() {
  ee.trigger("analytics.trackGTMEvent", [{
    type: "button",
    feature: "editorial board",
    label: "show tooltip"
  }, "clickEvent"]);
}
